import React, { useState } from "react";
import { formatMoney } from "../../utils";
import { useNavigate } from "react-router-dom";
import ProductAndServicesLoader from "./Loading/ProductAndServicesLoader";
import { IService } from "../../@types";
import { useServiceStore } from "../../state/useServiceStore";

const MostBookedServices = () => {
  const navigate = useNavigate();
  const { services, fetchData, isLoading } = useServiceStore();

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (isLoading) {
    return <ProductAndServicesLoader />;
  }
  return (
    <div className="rounded-lg bg-white items-stretch py-3 lg:py-6 flex w-full">
      <>
        {services?.length > 0 ? (
          <div className="flex flex-col justify-between w-full">
            <div className="w-full">
              <h2 className="px-3 md:px-6 text-[#1D2939] text-[16px] font-medium leading-6">
                Most Booked Services
              </h2>
              <hr className="border border-[#EAECF0] w-full mt-3 mb-2" />
              <div className="space-y-2 grid grid-cols-1 gap-4 px-3 md:px-6">
                {services?.splice(0, 5)?.map((service: IService, index) => (
                  <a
                    id={service.id}
                    key={index}
                    className="flex gap-[12%] items-center py-2 text-[16px]"
                    href={`/services/${service.id}/view`}
                  >
                    <div className="text-gray-700 capitalize w-full font-medium">
                      {service?.name}
                    </div>
                    <div className="flex items-center justify-between w-full font-semibold">
                      <span className="text-gray-600 leading-6">
                        {service.duration ? `${service.duration}hrs` : ""}
                      </span>

                      <span className="text-[#000000] leading-6">
                        {formatMoney(
                          service.price[0].amount,
                          service.price[0].currency,
                        )}
                      </span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
            <div className="flex justify-between mx-auto w-full items-center px-2">
              <button
                onClick={() => {
                  navigate("/services");
                }}
                className="border-[#044E97] mx-auto transition-all duration-500 hover:bg-[#044E97] hover:text-[#ffffff] p-[8px] border rounded-md text-[14px] font-medium text-[#044E97] "
              >
                View Services
              </button>
            </div>
          </div>
        ) : (
          <div className="flex flex-col justify-between w-full">
            <div className="w-full">
              <h2 className="px-3 md:px-6 text-[#1D2939] text-[16px] font-medium leading-6">
                Most Booked Services
              </h2>
              <hr className="border border-[#EAECF0] w-full mt-3 mb-2" />
              <div className="bg-white w-full flex md:py-16 justify-center items-center h-full p-3">
                <div className="flex flex-col justify-center items-center mt-10 gap-5">
                  <p className="text-[#344054] text-[14px] font-medium leading-5 text-center">
                    You do not have any services yet.
                  </p>
                  <button
                    onClick={() => {
                      navigate("/services/create");
                    }}
                    className="px-4 text-[#044E97] text-[14px] font-medium leading-5  cursor-pointer"
                  >
                    Create a service
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    </div>
  );
};

export default MostBookedServices;
